import React, { useState } from "react"
import { Button, Row, Col, Form, Label, Input, FormGroup } from "reactstrap"
import axios from "axios"
import { useFormik } from "formik"
import { useLocation, useNavigate } from "react-router-dom"
import * as Yup from "yup"
import { toast, ToastContainer } from "react-toastify"
import API from "api/axios"

const DoctorTimeTableProfile = () => {
    console.log("🔥 FUNCTION CALLED");
  document.title = "Edit Availability | Dashboard"

  const location = useLocation()
  const navigate = useNavigate()
  const availabilityData = location.state?.availabilityData || {}

  // console.log("😀😀😀availabilityData", availabilityData)

  const days = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ]

  const transformedAvailability = days.reduce((acc, day) => {
    const apiDay = availabilityData?.availability?.find(d => d.day === day)

    acc[day] = {
      available: apiDay?.available ?? false,
      start_time: apiDay?.starttime || "",
      end_time: apiDay?.endtime || "",
    }
    // console.log(day, apiDay?.available, typeof apiDay?.available)

    return acc
  }, {})

  const validation = useFormik({
    // enableReinitialize: false,
    initialValues: {
      // user_id: availabilityData.userId || "",
      speciality: availabilityData.services || "",
      availability: transformedAvailability,
    },
    validationSchema: Yup.object({
      availability: Yup.object().shape(
        days.reduce((acc, day) => {
          acc[day] = Yup.object({
            available: Yup.boolean(),
            start_time: Yup.string().when("available", {
              is: true,
              then: schema =>
                schema
                  .required("Start time is required")
                  .test(
                    "minute-multiple-5",
                    "Start time minutes must be a multiple of 5",
                    value => {
                      if (!value) return true
                      const minutes = parseInt(value.split(":")[1])
                      return minutes % 5 === 0
                    },
                  ),
              otherwise: schema => schema.notRequired(),
            }),

            end_time: Yup.string().when("available", {
              is: true,
              then: schema =>
                schema
                  .required("End time is required")
                  .test(
                    "minute-multiple-5",
                    "End time minutes must be a multiple of 5",
                    value => {
                      if (!value) return true
                      const minutes = parseInt(value.split(":")[1])
                      return minutes % 5 === 0
                    },
                  )
                  .test(
                    "is-after-start",
                    "End time must be after start time",
                    function (value) {
                      const { start_time, available } = this.parent
                      if (!available || !start_time || !value) return true
                      const [startHour, startMinute] = start_time
                        .split(":")
                        .map(Number)
                      const [endHour, endMinute] = value.split(":").map(Number)
                      const start = new Date()
                      start.setHours(startHour, startMinute, 0)
                      const end = new Date()
                      end.setHours(endHour, endMinute, 0)
                      return end > start
                    },
                  ),
              otherwise: schema => schema.notRequired(),
            }),
          })
          return acc
        }, {}),
      ),
    }),
    onSubmit: async values => {
      await updateAvailability(values)
       console.log("ERRORS:", validation.errors);
    },
  })

  React.useEffect(() => {
    console.log("😀😀Formik values changed:", validation.values.availability)
  }, [validation.values.availability])

  const formatTo24Hour = time => {
    const [hour, minute] = time.split(":").map(Number)
    return `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`
  }

  const updateAvailability = async updatedData => {
    try {
      const authToken = localStorage.getItem("authToken")
      const payload = {
        id: availabilityData.id,

        isMon: updatedData.availability.monday.available,
        monStarttime: updatedData.availability.monday.available
          ? formatTo24Hour(updatedData.availability.monday.start_time)
          : null,
        monEndtime: updatedData.availability.monday.available
          ? formatTo24Hour(updatedData.availability.monday.end_time)
          : null,

        isTues: updatedData.availability.tuesday.available,
        tuesStarttime: updatedData.availability.tuesday.available
          ? formatTo24Hour(updatedData.availability.tuesday.start_time)
          : null,
        tuesEndtime: updatedData.availability.tuesday.available
          ? formatTo24Hour(updatedData.availability.tuesday.end_time)
          : null,

        isWed: updatedData.availability.wednesday.available,
        wedStarttime: updatedData.availability.wednesday.available
          ? formatTo24Hour(updatedData.availability.wednesday.start_time)
          : null,
        wedEndtime: updatedData.availability.wednesday.available
          ? formatTo24Hour(updatedData.availability.wednesday.end_time)
          : null,

        isThurs: updatedData.availability.thursday.available,
        thursStarttime: updatedData.availability.thursday.available
          ? formatTo24Hour(updatedData.availability.thursday.start_time)
          : null,
        thursEndtime: updatedData.availability.thursday.available
          ? formatTo24Hour(updatedData.availability.thursday.end_time)
          : null,

        isFri: updatedData.availability.friday.available,
        friStarttime: updatedData.availability.friday.available
          ? formatTo24Hour(updatedData.availability.friday.start_time)
          : null,
        friEndtime: updatedData.availability.friday.available
          ? formatTo24Hour(updatedData.availability.friday.end_time)
          : null,

        isSat: updatedData.availability.saturday.available,
        satStarttime: updatedData.availability.saturday.available
          ? formatTo24Hour(updatedData.availability.saturday.start_time)
          : null,
        satEndtime: updatedData.availability.saturday.available
          ? formatTo24Hour(updatedData.availability.saturday.end_time)
          : null,
      }

      // console.log("Sending payload:", payload)


      // console.log("value", availabilityData.id)
      console.log("🙌🙌TOKEN:", authToken);
      const response = await API.put(
        `/doctorAvailibility/${availabilityData.id}`,

        payload,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        },
      )

      console.log("updated availability", response.data)

      if (response.status === 200) {
        toast.success("time table updated successfully", { autoClose: 2000 })
        setTimeout(() => navigate("/availability"), 2000)
      } else {
        toast.error("Failed to update time table. Please try again.")
      }
    } catch (error) {
      console.error("Error updating time table:", error)
      toast.error("Error updating time table.")
    }
  }

  // const handleDelete = async () => {
  //   if (!availabilityData?.id) {
  //     toast.error("Invalid time table data.")
  //     return
  //   }

  //   const confirmDelete = window.confirm(
  //     `Are you sure you want to delete doctor time table: ${availabilityData.user_id} ?`,
  //   )

  //   if (!confirmDelete) return

  //   try {
  //     const authToken = localStorage.getItem("authToken")
  //     const response = await axios.delete(
  //       `http://localhost:5000/api/doctorAvailibility/${availabilityData.id}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${authToken}`,
  //           "Content-type": "application/json",
  //         },
  //       },
  //     )

  //     if (response.status === 200) {
  //       toast.success("Profile deleted successfully!", { autoClose: 2000 })
  //       navigate("/availability")
  //     } else {
  //       toast.error("Failed to delete profile. Please try again.")
  //     }
  //   } catch (error) {
  //     console.error("Error deleting profile:", error)
  //     toast.error("Error deleting profile.")
  //   }
  // }

  return (
    <Form onSubmit={validation.handleSubmit}>
      <ToastContainer />
      <Row>
        <Col md="6">
          <FormGroup>
            <Label htmlFor="user_id">Doctor Name</Label>
            <Input
              type="text"
              id="user_id"
              value={availabilityData.name || ""}
              readOnly
            />
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup>
            <Label>Speciality</Label>
            <br></br>

            <div type="text" id="specialityTag" className="card">
              <h5>
                {availabilityData.services?.map((s, index) => (
                  <span key={index} className="badge text-bg-success p-2 m-1">
                    {s}
                  </span>
                ))}
              </h5>
            </div>
          </FormGroup>
        </Col>
      </Row>

      {days.map(day => (
        <div key={day}>
          <Row className="mt-3">
            <Row className="shadow lg p-3 rounded">
              <Col
                md="12"
                className="d-flex justify-content-between align-items-center"
              >
                <label check className="text-capitalize mb-0">
                  {day}
                </label>
                <FormGroup switch>
                  <Input
                    type="switch"
                    id={`avail-${day}`}
                    name={`availability.${day}.available`}
                    defaultChecked ={Boolean(
                      validation.values.availability?.[day]?.available,
                    )}
                    onChange={e => {
                      const newValue = e.target.checked
                      validation.setFieldValue(
                        `availability.${day}.available`,
                        newValue,
                      )
                    }}
                  />
                  <Label htmlFor={`avail-${day}`} className="mb-0">
                    {validation.values.availability?.[day]?.available
                      ? "Available"
                      : "Not Available"}
                  </Label>
                </FormGroup>
              </Col>

              <Col md="6" className="mt-2">
                <label>Start Time</label>
                <Input
                  type="time"
                  step={300}
                  name={`availability.${day}.start_time`}
                  value={validation.values.availability[day].start_time}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  disabled={!validation.values.availability[day].available}
                />
                {validation.touched.availability?.[day]?.start_time &&
                  validation.errors.availability?.[day]?.start_time && (
                    <div className="text-danger">
                      {validation.errors.availability[day].start_time}
                    </div>
                  )}
              </Col>

              <Col md="6" className="mt-2">
                <label>End Time</label>
                <Input
                  type="time"
                  step={300}
                  name={`availability.${day}.end_time`}
                  value={validation.values.availability[day].end_time}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  disabled={!validation.values.availability[day].available}
                />
                {validation.touched.availability?.[day]?.end_time &&
                  validation.errors.availability?.[day]?.end_time && (
                    <div className="text-danger">
                      {validation.errors.availability[day].end_time}
                    </div>
                  )}
              </Col>
            </Row>
          </Row>
        </div>
      ))}

      <div
        className="text-center mt-4 m-5"
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          type="submit"
          color="primary"
          className="px-3 border"
          disabled={validation.isSubmitting}
        >
          Update
        </Button>

        <Button
          type="button"
          color="secondary"
          className="px-3 border"
          onClick={() => navigate("/availability")}
        >
          Cancel
        </Button>
      </div>
    </Form>
  )
}

export default DoctorTimeTableProfile
